<template>
<div class="swaychat-group-time swaychat-row swaychat-faux">
  <div class="swaychat-status swaychat-bounceIn">
    <h5>
      <span>
        <i></i><i></i>
        <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        <i></i><i></i><i></i><i></i>
      </span>
    </h5>
  </div>
</div>
</template>

<script>
import moment from 'moment'

export default {
}

</script>
